import { __rest as e } from "tslib";
import * as s from "react";
import t from "classnames";
import { ComponentClassNames as a, ComponentText as i } from "../shared/constants.js";
import { isFunction as r, classNameModifier as o } from "../shared/utils.js";
import { View as l } from "../View/View.js";
import { Flex as m } from "../Flex/Flex.js";
import { Button as n } from "../Button/Button.js";
import { AlertIcon as c } from "./AlertIcon.js";
import { IconClose as d } from "../Icon/icons/IconClose.js";
const f = s.forwardRef((f, p) => {
  var {
      buttonRef: u,
      children: b,
      className: h,
      dismissButtonLabel: j = i.Alert.dismissButtonLabel,
      hasIcon: A = !0,
      heading: E,
      isDismissible: N = !1,
      onDismiss: v,
      variation: B
    } = f,
    D = e(f, ["buttonRef", "children", "className", "dismissButtonLabel", "hasIcon", "heading", "isDismissible", "onDismiss", "variation"]);
  const [I, g] = s.useState(!1),
    x = s.useCallback(() => {
      g(!I), r(v) && v();
    }, [g, v, I]);
  return !I && s.createElement(m, Object.assign({
    className: t(a.Alert, h, o(a.Alert, B)),
    "data-variation": B,
    ref: p,
    role: "alert"
  }, D), A && s.createElement(c, {
    variation: B,
    ariaHidden: !0
  }), s.createElement(l, {
    flex: "1"
  }, E && s.createElement(l, {
    className: a.AlertHeading
  }, E), s.createElement(l, {
    className: a.AlertBody
  }, b)), N && s.createElement(n, {
    ariaLabel: j,
    variation: "link",
    className: a.AlertDismiss,
    onClick: x,
    ref: u
  }, s.createElement(d, {
    "aria-hidden": "true"
  })));
});
f.displayName = "Alert";
export { f as Alert };